import ExamResultParent from "./ExamResultParent"
import ExamResultTable from "./ExamResultTable"
import './ExamResultMain.scss'

function ExamResultMain() {
    return (
        <div className="main">
            <ExamResultParent/>
            <ExamResultTable/>
        </div>
    )
}

export default ExamResultMain
